import { render } from "./NewPaymentPage.vue?vue&type=template&id=4af6fd1d&ts=true"
import script from "./NewPaymentPage.vue?vue&type=script&lang=ts"
export * from "./NewPaymentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__